import {createContext, use} from 'react'

const PreviewUrlContext = createContext<string>('')

export function PreviewUrlProvider({value, children}: {value: string; children: React.ReactNode}) {
  return <PreviewUrlContext value={value}>{children}</PreviewUrlContext>
}

export function usePreviewUrl(): string {
  return use(PreviewUrlContext)
}
